import {Base} from "./base";

class Stage extends Base
{
	static type()
	{
		return 'stage';
	}
	getType()
	{
		return Stage.type();
	}
}

export
{
	Stage
}